/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableForAllocationOriginalCurrencyOptionDto
 */
export interface AvailableForAllocationOriginalCurrencyOptionDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableForAllocationOriginalCurrencyOptionDto
     */
    originalCurrency: string;
}

/**
 * Check if a given object implements the AvailableForAllocationOriginalCurrencyOptionDto interface.
 */
export function instanceOfAvailableForAllocationOriginalCurrencyOptionDto(value: object): value is AvailableForAllocationOriginalCurrencyOptionDto {
    if (!('originalCurrency' in value) || value['originalCurrency'] === undefined) return false;
    return true;
}

export function AvailableForAllocationOriginalCurrencyOptionDtoFromJSON(json: any): AvailableForAllocationOriginalCurrencyOptionDto {
    return AvailableForAllocationOriginalCurrencyOptionDtoFromJSONTyped(json, false);
}

export function AvailableForAllocationOriginalCurrencyOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableForAllocationOriginalCurrencyOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'originalCurrency': json['originalCurrency'],
    };
}

export function AvailableForAllocationOriginalCurrencyOptionDtoToJSON(json: any): AvailableForAllocationOriginalCurrencyOptionDto {
    return AvailableForAllocationOriginalCurrencyOptionDtoToJSONTyped(json, false);
}

export function AvailableForAllocationOriginalCurrencyOptionDtoToJSONTyped(value?: AvailableForAllocationOriginalCurrencyOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'originalCurrency': value['originalCurrency'],
    };
}

